let Chathub = function (tokenClient, serviceAddr) {
  let TokenClient = tokenClient;
  let ServiceBaseAddress = serviceAddr;
  
  this.AddOrganizationChat = function (userInfo, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/AddOrganizationChat?userId=${userInfo.userId}&userName=${userInfo.userName}&sex=${userInfo.sex}&account=${userInfo.account}&orgId=${userInfo.organizationId}&orgName=${userInfo.organizationName}&filePath=%20&isServer=${userInfo.isServer}`;
    TokenClient.Post(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.AddChatDiseaseServer = function (item, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/AddChatDiseaseServer`;
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.EditChatDiseaseServer = function (item, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/EditChatDiseaseServer`;
    TokenClient.Post(
      url,
      true,
      { "Content-Type": "application/json" },
      item,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.GetOrganizationChat = function (organizationId, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/GetOrganizationChat/${organizationId}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.GetOrganizationChatDisease = function (organizationId, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/GetOrganizationChatDisease/${organizationId}/false`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.GetOrganizationChatDiseaseIds = function (success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/GetOrganizationChatDiseaseIds/false`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.GetOrganizationChatIds = function (success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/GetOrganizationChatIds/false`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.GetUserGroup = function (userId, organizationId,success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/GetUserGroup/${userId}/${organizationId}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.GetUserNotReadMessage = function (success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/GetUserNotReadMessage`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.AddToCustomerGroup = function (userId, organizationId, pageIndex, pageSize, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/AddToCustomerGroup/${userId}/${organizationId}/${pageIndex}/${pageSize}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  
  this.AddToCustomerGroupDisease = function (pageIndex, pageSize, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/AddToCustomerGroupDisease/${pageIndex}/${pageSize}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.AddToOrgizationGroup = function (organizationId, userId, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/AddToOrgizationGroup?organizationId=${organizationId}&userId=${userId}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.SetUserOnLine = function (success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/SetUserOnLine?userId=1913&isOnline=true`;
    TokenClient.Post(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  
  this.MessageIsReader = function (groupId, userId, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/MessageIsReader/${groupId}/${userId}`;
    TokenClient.Post(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.GetGroupHistoryChatMessage = function (groupId, userId, pageIndex, pageSize, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/GetGroupHistoryChatMessage/${groupId}/${userId}/${pageIndex}/${pageSize}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.AddToChatDiseaseGroup = function (userId, orderNumber, doctorName, doctorId, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/AddToChatDiseaseGroup/${userId}/${orderNumber}/${doctorName}/${doctorId}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  this.DiseaseServerStartChat = function (groupId, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/DiseaseServerStartChat/${groupId}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
  
  this.GetDiseaseGroupHistoryChatMessageServer = function (userId ,orderNumber, success, error) {
    var url = ServiceBaseAddress + `/api/ChatHub/GetDiseaseGroupHistoryChatMessageServer/${userId}/${orderNumber}`;
    TokenClient.Get(
      url,
      true,
      null,
      null,
      function (data) {
        if (success) {
          var jsonObj = JSON.parse(data);
          success(jsonObj);
        }
      },
      error
    );
  };
};

export { Chathub };
